// extracted by mini-css-extract-plugin
module.exports = {"container":"v_tag_radio_container_container__13Vvg","tag":"v_tag_radio_container_tag__3aNVw","tag_active":"v_tag_radio_container_tag_active__7pnvj"};